<template>
    <ValidationObserver ref="form" tag="div" v-slot="{ handleSubmit }">
        <form class="columns is-multiline is-variable is-4-mobile is-4-tablet is-4-desktop" @submit.prevent="handleSubmit(handle)">
            <div class="column is-full-mobile is-full-tablet is-7-desktop">
                <ValidationObserver tag="div" class="field-container">
                    <ValidationProvider tag="div" name="product" :rules="{ required: true }" v-slot="{ errors }">
                        <div class="selector-product">
                            <select name="product" id="types" v-model="product">
                                <option value="" selected>Select product type</option>
                                <option v-for="(product, index) in products" :key="index" :value="product.name" v-text="product.name" />
                            </select>
                        </div>
                        <span class="is-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                </ValidationObserver>
    
                <ValidationObserver tag="div" class="field-container">
                    <ValidationProvider tag="div" name="type" :rules="{ required: true }" v-slot="{ errors }">
                        <div class="selector-type">
                            <select name="type" id="types" v-model="type">
                                <option value="" selected>Select wood type</option>
                                <option v-for="(option, index) in options" :key="index" :value="option" v-text="option" />
                            </select>
                        </div>
                        <span class="is-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                </ValidationObserver>
            </div>

            <div class="column is-full-mobile is-full-tablet is-5-desktop">
                <ValidationObserver tag="div" class="field-container">
                    <ValidationProvider tag="div" name="height" :rules="{ required_alt: true }" v-slot="{ errors }">
                        <input type="text" class="height" name="height" placeholder="Height (m)" v-model="height" />
                        <span class="is-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                </ValidationObserver>
                
                <ValidationObserver tag="div" class="field-container">
                    <ValidationProvider tag="div" name="width" :rules="{ required_alt: true }" v-slot="{ errors }">
                        <input type="text" class="width" name="width" placeholder="Width (m)" v-model="width" />
                        <span class="is-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                </ValidationObserver>
            </div>

            <div class="column is-full-mobile is-full-tablet is-7-desktop">
                <button class="btn btn-tertiary" type="submit">
                    <span class="btn-text">Calculate</span>
                    <figure class="btn-icon">
                        <span class="inline-svg" style="padding-top: 100%">
                            <button-arrow />
                        </span>
                    </figure>
                </button>
            </div>
        </form>
    </ValidationObserver>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import coverage from '~/data/coverage'
import { EventBus } from '~/event-bus.js'
import { isEmpty } from '~/misc/Utils'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    mounted() {
        EventBus.$on('reset', () => {
            this.reset()
        })
    },
    data: () => ({
        height: null,
        width: null,
        length: null,
        product: '',
        type: '',
        options: [],
        products: [
            {
                name: 'Wood Protector',
                options: ['Rough Wood', 'Smooth Wood', 'Redecoration'],
            },
            {
                name: 'Wood Preserver',
                options: ['Rough Wood', 'Smooth Wood'],
            },
            {
                name: 'Water Sealer',
                options: ['Rough Wood', 'Smooth Wood'],
            },
            {
                name: 'Decking Protector',
                options: ['Untreated', 'Redecoration'],
            },
            {
                name: 'Shed and Fence Protector',
                options: ['Shed and Fence', 'Redecoration'],
            },
            // {
            //     name: 'Garden Paint',
            //     options: ['Rough Wood', 'Smooth Wood', 'Redecoration'],
            // },
        ],
    }),
    watch: {
        product: function (newValue) {
            if (isEmpty(newValue)) {
                return
            }

            this.type = ''
            this.options = this.products.find((product) => product.name === newValue).options
        },
    },
    methods: {
        handle() {
            this.calculate()
        },
        calculate() {
            // caclulate an area m2
            const area = parseFloat(this.height * this.width).toFixed(1)

            // get product from coverage data
            const info = { coverage: null, comments: null }
            const product = coverage.find((item) => item.product === this.product)

            if (product) {
                // get type from product data
                const type = product.types.find((item) => item.name === this.type)
                info.handle = product.handle
                info.coverage = type.coverage
                info.comments = product.comments
            }

            const results = {
                area
            }

            this.$store.commit('calculator/SET_DATA', { info, results })
        },
        reset() {
            this.$store.commit('calculator/RESET')

            this.$nextTick(() => {
                this.height = null
                this.width = null
                this.length = null
                this.product = ''
                this.type = ''

                this.$refs.form.reset()
            })
        },
    },
}
</script>
